// Glass-i — Item Configuration constants (Stage 6B.8A-2A).

export const CATEGORY_TYPE_OPTIONS = Object.freeze([
  { value: 'erp',        label: 'ERP' },
  { value: 'inventory',  label: 'Inventory' },
  { value: 'purchase',   label: 'Purchase' },
  { value: 'sales',      label: 'Sales' },
  { value: 'production', label: 'Production' },
  { value: 'service',    label: 'Service' }
]);

export const CATEGORY_TYPE_COLOR = Object.freeze({
  erp:        'blue',
  inventory:  'geekblue',
  purchase:   'orange',
  sales:      'green',
  production: 'magenta',
  service:    'cyan'
});

export const MATERIAL_FAMILY_OPTIONS = Object.freeze([
  { value: 'glass',      label: 'Glass' },
  { value: 'hardware',   label: 'Hardware' },
  { value: 'profile',    label: 'Profile' },
  { value: 'consumable', label: 'Consumable' },
  { value: 'jobwork',    label: 'Jobwork' },
  { value: 'service',    label: 'Service' },
  { value: 'trading',    label: 'Trading' },
  { value: 'other',      label: 'Other' }
]);

export const MATERIAL_FAMILY_COLOR = Object.freeze({
  glass:      'cyan',
  hardware:   'orange',
  profile:    'geekblue',
  consumable: 'gold',
  jobwork:    'magenta',
  service:    'green',
  trading:    'blue',
  other:      'default'
});

// Template-defaults vocabulary — lockstep with backend itemConfig.constants.
export const ITEM_TYPE_OPTIONS = Object.freeze([
  { value: 'finished_good',    label: 'Finished Good' },
  { value: 'trading_good',     label: 'Trading Good' },
  { value: 'jobwork_service',  label: 'Jobwork Service' },
  { value: 'consumable',       label: 'Consumable' },
  { value: 'service',          label: 'Service' }
]);

export const MEASUREMENT_MODE_OPTIONS = Object.freeze([
  { value: 'qty_based',     label: 'Qty Based' },
  { value: 'area_based',    label: 'Area Based' },
  { value: 'length_based',  label: 'Length Based' },
  { value: 'volume_based',  label: 'Volume Based' },
  { value: 'weight_based',  label: 'Weight Based' },
  { value: 'service_based', label: 'Service Based' }
]);

export const PRICING_METHOD_OPTIONS = Object.freeze([
  { value: 'qty_based',    label: 'Qty Based' },
  { value: 'area_based',   label: 'Area Based' },
  { value: 'length_based', label: 'Length Based' },
  { value: 'volume_based', label: 'Volume Based' },
  { value: 'weight_based', label: 'Weight Based' },
  { value: 'fixed_rate',   label: 'Fixed Rate' }
]);

export const INPUTTYPE_OPTIONS = Object.freeze([
  { value: 'MM',  label: 'MM (Millimeter input → roll up to MTR/SQM)' },
  { value: 'OTH', label: 'OTH (Other / count / service)' }
]);
